module.exports = "data:image/gif;base64,R0lGODlhDQAJAJEAAAAAAP///////wAAACH5BAEAAAIALAAAAAANAAkAAAITlB2HKql+4HpMtspmzJdma2lLAQA7"